import React from 'react';
import './CTASection.css';

// Set to false to re-enable consultation form submissions
const FORM_SUBMISSIONS_DISABLED = true;

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-split-layout">
          <div className="cta-left">
            <div className="cta-form-container">
              <h3 className="form-title">Embark on Your Global Journey</h3>
              <p className="form-subtitle">
                Connect with our experts to explore immigration, investment, and business opportunities across six continents.
              </p>
              <form className="cta-form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-row">
                  <input type="text" placeholder="First Name" className="cta-form-input" disabled={FORM_SUBMISSIONS_DISABLED} />
                  <input type="text" placeholder="Last Name" className="cta-form-input" disabled={FORM_SUBMISSIONS_DISABLED} />
                </div>
                <input type="email" placeholder="Email Address" className="cta-form-input full-width" disabled={FORM_SUBMISSIONS_DISABLED} />
                <input type="tel" placeholder="Phone Number" className="cta-form-input full-width" disabled={FORM_SUBMISSIONS_DISABLED} />
                <select className="cta-form-input full-width" disabled={FORM_SUBMISSIONS_DISABLED}>
                  <option>Select Service Interest</option>
                  <option>Software Development</option>
                  <option>Cybersecurity Services</option>
                  <option>Blockchain & Crypto</option>
                  <option>Electronic Intrusion Detection</option>
                  <option>Education Technology</option>
                  <option>Biotech & Longevity</option>
                  <option>Immigration & Citizenship</option>
                  <option>Corporate Services</option>
                  <option>Business Advisory</option>
                  <option>Emirati & Contemporary Art</option>
                </select>
                <textarea placeholder="Tell us about your specific needs - citizenship goals, business formation requirements, investment interests, or other services..." className="cta-form-textarea" disabled={FORM_SUBMISSIONS_DISABLED}></textarea>
                <button type="submit" className="form-submit-btn" disabled={FORM_SUBMISSIONS_DISABLED}>
                  Schedule Consultation
                  <span className="cta-btn-arrow">→</span>
                </button>

                {FORM_SUBMISSIONS_DISABLED && (
                  <p className="form-disabled-notice">
                    Form submissions are temporarily unavailable. Please email us at{' '}
                    <a href="mailto:info@rayadgroup.com">info@rayadgroup.com</a>.
                  </p>
                )}
              </form>
            </div>
          </div>
          
          <div className="cta-right">
            <div className="cta-content-right">
              <h2 className="cta-title-v3">Unlock Global Opportunities</h2>
              <p className="cta-description-v3">
                From software development and cybersecurity services to blockchain & crypto, electronic intrusion detection, education technology, biotech & longevity, immigration & citizenship, corporate services, business advisory, and Emirati & contemporary art, Rayad Group has delivered comprehensive solutions across 6 continents since 1994.
              </p>
              
              <div className="feature-list">
                <div className="feature-item">
                  <div className="feature-text">
                    <strong>Enterprise Security</strong>
                    <span>AI-Powered Threat Intelligence and Compliance</span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-text">
                    <strong>Global Citizenship Programs</strong>
                    <span>EB-5 USA, St. Kitts & Nevis, and Vanuatu</span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-text">
                    <strong>Business Formation</strong>
                    <span>UAE Free Zones, Legal, and Financial Services</span>
                  </div>
                </div>
              </div>
              
              <div className="trust-indicators">
                <div className="trust-item">
                  <span className="trust-number">6</span>
                  <span className="trust-label">Continents</span>
                </div>
                <div className="trust-item">
                  <span className="trust-number">150+</span>
                  <span className="trust-label">Country Access</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;